import OtpRecordsPage from "../../otps/OtpRecordsPage";

export default function OTPs() {
  return (
    <OtpRecordsPage
      apiPath="/otps"
      fallbackNote="OTP records for users in your agency only."
    />
  );
}
